export enum CategoryArticlesProperty {
  videoHighlight = 'videoHighlight',
  textHighlight = 'textHighlight',
  photoHighlight = 'photoHighlight',

  video = 'video',
  text = 'text',
  photo = 'photo',
}
